import type { EditionConfig } from './types.js';

/**
 * The adult edition. The name is a WORKING TITLE: "MindGames" is under a trademark check
 * (docs/audits/2026-10-16-mindgames-name-check.md) and may change, with a qualifier or entirely. Play money only,
 * never real money (docs/proposals/mindgames-editions.md). Today its catalog equals the child edition's; adult-only
 * games (Twenty-One, Poker Showdown) are added here when they are built, and only here.
 */
export const ADULT: EditionConfig = {
  id: 'adult',
  brand: {
    name: 'Strategy Mind',
    shortName: 'Strategy Mind',
    tagline: 'Chess, backgammon, mahjong, card games and classics, with a friendly robot opponent.',
    description: 'Chess, checkers, backgammon and card games against friendly robot opponents.',
    // The gold knight on midnight indigo (apps/app/resources/icon-adult.png, the app icon), as a transparent logo and the install icons.
    // They live under public/adult/, which every OTHER edition's build output has removed (vite.config.ts): the child build never carries them.
    logo: '/adult/logo.png',
    favicon: '/adult/favicon.png',
    iconDir: '/adult/icons',
  },
  // A calm ladder for adults in place of the child's animals. Same ids, so the same difficulty (400 / 800 / 1200 / 1600 / 2000 Elo) and test ids.
  levelNames: { kitten: 'Beginner', puppy: 'Casual', rookie: 'Club', student: 'Expert', coach: 'Master' },
  gameNoun: 'match',
  // The blue accent that already exists in the theme, to sit with the indigo and gold of the adult logo; a player's own pick still wins.
  accent: 'ocean',
  // The store bundle id, settled 2026-10-24: the App Store Connect record "Strategy Mind" (app id 6826652909) is bound to
  // studio.blueforge.strategymind, so this must match the binary exactly (docs/proposals/strategy-mind-native-app.md).
  // A store app's id cannot be changed after a build is uploaded.
  native: { appId: 'studio.blueforge.strategymind', webDir: 'dist-adult', iosPath: 'ios-adult', androidPath: 'android-adult' },
  games: ['chess', 'checkers', 'backgammon', 'bridge', 'whist', 'crazy-eights', 'hearts', 'mahjong-solitaire', 'rummy', 'colour-dash', 'pirate'],
  // New games start in beta: shown only to players who opted in (?beta=1) until they are promoted to prod.
  stages: { 'crazy-eights': 'beta', hearts: 'beta', 'mahjong-solitaire': 'beta', rummy: 'beta', 'colour-dash': 'beta', pirate: 'beta' },
};
